import { FunctionComponent, memo } from "react";
import { Field, Form, Formik } from "formik";
import { SubmitOnChange } from "@edgetier/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/pro-solid-svg-icons";

import { IProps, IUsersFilters } from "./users-filters.types";
import "./users-filters.scss";

/**
 * Filters for the users table.
 * @param props.onSubmit A function that runs when the filters are submitted.
 */
const UsersFilters: FunctionComponent<IProps> = ({ onSubmit }) => (
    <Formik<IUsersFilters> onSubmit={onSubmit} initialValues={{ search: "" }}>
        <Form className="users-filters" name="users-filters-form">
            <div className="field field-inline">
                <div className="field-inline__icon">
                    <FontAwesomeIcon icon={faSearch} />
                </div>
                <Field name="search" placeholder="Search&hellip;" type="text" />
            </div>
            <SubmitOnChange />
        </Form>
    </Formik>
);

export default memo(UsersFilters);
